import { z } from 'zod';

export const ApiErrorSchema = z.object({
    error: z.string(),
    message: z.string().optional(),
    code: z.string().optional(),
    details: z.string().optional(),
    requestId: z.string().optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export const ApiResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
    z.object({
        data: dataSchema,
        message: z.string().optional(),
    });

export const EmailSchema = z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid(),
    scan_job_id: z.string().uuid(),
    message_id: z.string(),
    category : z.string(),
    thread_id: z.string(),
    from_address: z.string().email(),
    subject: z.string(),
    received_at: z.coerce.date(),
    size_bytes: z.number().int().nonnegative(),
    snippet: z.string(),
    labels: z.record(z.string(), z.unknown()),
    headers: z.record(z.string(), z.unknown()),
    created_at: z.coerce.date(),
    expires_at: z.coerce.date(),
    is_analyzed: z.boolean(),
    is_resolved: z.boolean(),
});

export type Email = z.infer<typeof EmailSchema>;

export const EmailPreviewSchema = z.object({
    id: z.string().describe('Database row id or Gmail message id'),
    message_id: z.string().describe('Gmail message ID'),
    thread_id: z.string().optional().describe('Gmail thread ID (if available)'),
    from_address: z.string().describe('Sender email address'),
    subject: z.string().nullable().optional().default('').describe('Email subject (may be empty)'),
    snippet: z.string().default('').describe('Gmail snippet preview'),
    received_at: z.string().datetime().optional().describe('ISO timestamp when received'),
    category: z.string().nullable().optional().describe('Categorization/label for suggestion flows'),
    labels: z.array(z.string()).default([]).describe('Gmail label names or IDs'),
    source: z.enum(['db', 'gmail']).default('db').optional().describe('Preview source'),
});

export type EmailPreview = z.infer<typeof EmailPreviewSchema>;
